export default "__VITE_PUBLIC_ASSET__c711b26f__"